
      export interface IntrospectionResultData {
        __schema: {
          types: {
            kind: string;
            name: string;
            possibleTypes: {
              name: string;
            }[];
          }[];
        };
      }
      const result: IntrospectionResultData = {
  "__schema": {
    "types": [
      {
        "kind": "UNION",
        "name": "NavColumn",
        "possibleTypes": [
          {
            "name": "NavImageColumn"
          },
          {
            "name": "NavListColumn"
          }
        ]
      },
      {
        "kind": "UNION",
        "name": "PumoModule",
        "possibleTypes": [
          {
            "name": "DividerPumoModule"
          },
          {
            "name": "SinglePumoModule"
          },
          {
            "name": "MultiPumoModule"
          },
          {
            "name": "CarouselPumoModule"
          },
          {
            "name": "RecommendationsPumoModule"
          },
          {
            "name": "HomePageHeaderPumoModule"
          },
          {
            "name": "EmailPumoModule"
          },
          {
            "name": "PillsPumoModule"
          },
          {
            "name": "TrunkshowCountdownPumoModule"
          },
          {
            "name": "LivestreamPumoModule"
          }
        ]
      },
      {
        "kind": "UNION",
        "name": "CarouselCell",
        "possibleTypes": [
          {
            "name": "Variant"
          },
          {
            "name": "Look"
          },
          {
            "name": "Trunkshow"
          },
          {
            "name": "Slide"
          }
        ]
      },
      {
        "kind": "INTERFACE",
        "name": "Node",
        "possibleTypes": [
          {
            "name": "Variant"
          }
        ]
      }
    ]
  }
};
      export default result;
    